<template>
  <v-menu :nudge-left="220" :nudge-bottom="50" min-width="300" attach="#top-nav-toolbar">
    <template v-slot:activator="{ on }">
      <v-btn class="top-nav__button" :ripple="false" depressed v-on="on" v-if="$vuetify.breakpoint.mdAndUp">
        <v-icon x-large>account_circle</v-icon>
      </v-btn>
    </template>
    <top-nav-pull-down :navItems="items"></top-nav-pull-down>
  </v-menu>
</template>

<script>
  import TopNavPullDown from './TopNavPullDown';
  import syncService from '@/services/sync';
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'TopNavAccountMenu',
    components: {
      TopNavPullDown
    },
    data () {
      return {
        items: []
      }
    },
    created () {
      this.items = [
        { heading: 'Account Name', subtitle: 'Property Manager', sectionHeader: true },
        { title: 'ResMan Homepage', action: 'goToResman' },
        { title: 'Sync', action: 'syncReplicatedEntities' },
        { title: 'Logout', action: 'logout' }
      ]
      this.setUser();
      this.$eventHub.$on('syncReplicatedEntities', this.syncReplicatedEntities);
    },
    methods: {
      ...mapActions(['activateErrorDialog']),
      setUser () {
        if (this.currentUser) {
          this.items[0].heading = this.currentUser.profile.name
          this.items[0].subtitle = this.currentUser.profile.email
        }
      },
      async syncReplicatedEntities () {
          let response = await syncService.syncReplicatedEntities();
          if (response) {
            this.$eventHub.$emit('replicatedEntitiesSynced');
            this.$eventHub.$emit('showAlertNotification', 'GL account, property and unit type information successfully synced!');
          }
          else {
            this.activateErrorDialog({title: 'Sync Failed', message: 'An error occurred syncing GL account, property and unit type information. Please try again.'});
          }
      }
    },
    computed: {
      ...mapGetters(['currentUser'])
    },
    watch: {
      currentUser: function (val) {
        if (val) {
          this.setUser()
        }
      }        
    }
  }
</script>

<style lang="scss" scoped>
  .v-menu__content {
    border-radius: 0;
  }
  .top-nav__button {
    width: 40px;
    height: 40px !important;
    min-width: 0px;
    border-radius: 0px;
    margin-top: 5px;
    margin-left:10px !important;
    background-color: transparent !important;
    &:focus{
      box-shadow: 0 2px 0 white;
      background-color: transparent;
    }
    &:hover{
      background-color: transparent;
      box-shadow: 0 2px 0 white;
    }
    &:before{
      background-color: transparent;
    }
    &:focus:before{
      background-color: transparent;
    }
  }
</style>
